import React, { Fragment, useEffect } from "react";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../../utils/toastMessage/toastMessage";
import { setUserInfoAction } from "./../../../../redux/actions/userInfoActions/userInfoActions";
import {
  editInfoService,
  sendUserProfilePhotoService,
} from "../../../../services/userServices";
import { getBase64 } from "./../../../../utils/index";

const EditAvatarAdmin = () => {
  // Get User Profile Data
  const userInfo = useSelector((state) => state.userInfo);

  // Redux Dispatch
  const dispatch = useDispatch();

  // Handle Send User Profile Photo Method
  const handleSendUserProfilePhoto = async (event, profilePhoto) => {
    event.preventDefault();

    let base64 = "";
    await getBase64(profilePhoto)
      .then((v) => (base64 = v.split("base64,")[1]))
      .catch((er) => console.log(er));

    const objData = {
      base64,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await sendUserProfilePhotoService(objData);
      if (status === 200) {
        try {
          const { status } = await editInfoService({
            avatar: data.filename,
          });
          if (status === 200) {
            dispatch(setUserInfoAction());
          }
        } catch ({ response }) {
          if (response) {
            if (response.status) {
              toastErrorMessage();
            }
          }
        }
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage();
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  useEffect(() => {
    const readURL = (input) => {
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          $("#imagePreview").css(
            "background-image",
            "url(" + e.target.result + ")"
          );
          $("#imagePreview").hide();
          $("#imagePreview").fadeIn(650);
        };
        reader.readAsDataURL(input.files[0]);
      }
    };

    $("#imageUpload").change(function () {
      readURL(this);
    });
  }, []);

  return (
    <Fragment>
      <div className="avatar-upload">
        <div className="avatar-edit">
          <input
            type="file"
            id="imageUpload"
            accept="image/,.jpg,.jpeg,.png;capture=camera"
            onChange={(e) => {
              handleSendUserProfilePhoto(e, e.target.files[0]);
            }}
          />
          <label for="imageUpload">
            <i className="fas fa-pen mt-2"></i>
          </label>
        </div>
        <div className="avatar-preview">
          <div
            id="imagePreview"
            style={{
              backgroundImage: `url(${userInfo.avatar})`,
            }}
          ></div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditAvatarAdmin;
